import { AutoRechargeSettings, AddonDetails } from '../types'

export const DEFAULT_AUTO_RECHARGE_LIMIT = 10
export const DEFAULT_AUTO_RECHARGE_THRESHOLD = 90

export const isAutoRechargeLimitReached = (settings: AutoRechargeSettings[keyof AutoRechargeSettings]): boolean => {
  return !settings.enabled && settings.disabled_reason === 'exceeded_limit'
}

export const isAutoRechargePaymentFailed = (settings: AutoRechargeSettings[keyof AutoRechargeSettings]): boolean => {
  return !settings.enabled && settings.disabled_reason === 'payment_failed'
}

export const getAddonInitialAutoRechargeLimit = (addon: AddonDetails | undefined) => {
  if (!addon || !addon.autoRecharge?.settings) {
    return DEFAULT_AUTO_RECHARGE_LIMIT
  }
  if (addon.autoRecharge.settings.limit) {
    return addon.autoRecharge.settings.limit
  }
  if (isAutoRechargeLimitReached(addon.autoRecharge.settings)) {
    return Math.max(addon.currentQuantity ?? 0, 1)
  }
  return DEFAULT_AUTO_RECHARGE_LIMIT
}
